<template>
  <div class="submission-message" @click.capture="handleCloseClick">
    <div class="submission-message__frame">
      <SubmissionLightboxClose @click="handleCloseClick"/>
      <div class="submission-message__message">
        <InfoIcon class="submission-message__icon"/>
        <div v-html="message" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * contest submission message
 */
import InfoIcon from './../components/info-icon';
import SubmissionLightboxClose from './../components/submission-lightbox-close';
import { SUBMISSION_STATUS_MESSAGES, SUBMISSION_ERROR_MESSAGES, errors } from './../core/config'; // eslint-disable-line

export default {
  name: 'submission-message',
  props: {
    messageType: { type: String },
  },
  components: {
    SubmissionLightboxClose,
    InfoIcon,
  },
  computed: {
    message() {
      let out = SUBMISSION_STATUS_MESSAGES[this.messageType];
      console.log(out, this.messageType);
      if (!out) {
        out = SUBMISSION_ERROR_MESSAGES[this.messageType];
      }

      return out || SUBMISSION_ERROR_MESSAGES[errors.SUBMISSION_NOT_FOUND];
    }
  },
  methods: {
    /**
     * Send singnal to close message
     */
    handleCloseClick() {
      this.$emit('close');
    }
  },
};
</script>

<style lang="scss">

$submission-thumbnail-ratio: $ratio-height-image-submission / $ratio-width-image-submission;

.submission-message {
  display: block;
  width: $size-max-width-submissions-section-thumbnail-large;
  min-width: $size-min-width-submissions-section-thumbnail-large;
  flex: 1 0 auto;
  position: relative;
  text-align: center;
  height: 100%;
  width: 100%;
  background-color: $color-background-submission-message-base;
  &:before {
    content: '';
    display: block;
    padding-bottom: percentage($number: $submission-thumbnail-ratio);
  }

  &__frame {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border:
      $size-border-submissions-section-thumbnail-large
      solid
      $color-border-submissions-section-thumbnail-base;
    border-radius: $size-border-radius-submissions-section-thumbnail-large;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;

  }
  &__message {
    @include body-copy-small;
    color: $color-text-submission-message;
    width: 60%;
    margin: 0 auto;

    @include media(small) {
      width: 80%;
      @include body-copy-small;
      margin: 0 auto;
    }
  }

  &__icon.info-icon {
    cursor: auto;
    margin-bottom: $size-margin-bottom-submission-message;
  }
}
</style>
